import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
// import { DataTablesModule } from 'angular-datatables';
// import { ChartsModule } from 'ng2-charts';
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { AppRoutingModule } from '../app.routing';
import { SharedModule } from '../shared';
import { DateFormatPipe } from './DateFormat.Pipe';
import { DateMon } from './Datemon';
import { DateShort } from './Dateshort';
import { ActivityBoardComponent } from './activityboard/activityboard.component';
import { AddcareComponent } from './addcare/addcare.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { PAssementComponent } from './assement/passement.component';
import { SucesstempComponent } from './assessmentsucess/sucesstemp.component';
import { CarefamilyComponent } from './carefamily/carefamily.component';
import { ContactmeComponent, SafeHtmltestPipe } from './contactme/contactme.component';
import { DefaultcontactusComponent } from './contactme/defaultcontactus/defaultcontactus.component';
import { CustomMaxDirective } from './custom-max-validator.directive';
import { CustomMinDirective } from './custom-min-validator.directive';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboarddComponent } from './dashboard2/dashboard2.component';
import { DocumentComponent } from './document/document.component';
import { DocumentsComponent } from './documents/documents.component';
import { ExercisevideosComponent } from './exercisevideos/exercisevideos.component';
import { HelpdeskpageComponent } from './helpdesk/helpdesk.component';
import { MessageComponent } from './messages/messages.component';
import { MyprofileComponent } from './myprofile/myprofile.component';
import { OnlyAlphanumericDirective } from './only-alphanumeric.directive';
import { OnlyNumberDirective } from './only-number.directive';
import { OnlycharactersDirective } from './onlycharacters.directive';
import { PainlevelComponent } from './painlevel/painlevel.component';
import { PatientAssessmentDetailsComponent } from './patient-assessment-details/patient-assessment-details.component';
import { PatientComponent } from './patient.component';
import { PatsyComponent } from './patsy/patsy.component';
import { PostoperativeComponent } from './postoperative/postoperative.component';
import { PreventinginfectionComponent } from './preventinginfection/preventinginfection.component';
import { ProfilequesComponent } from './profileques/profileques.component';
import { ReportComponent } from './report/report.component';
import { StringFormatPipePipe } from './string-format-pipe.pipe';
import { SafeHtmlPipe } from './string-html.pipe';
import { SupportComponent } from './support/support.component';
import { SurveysComponent } from './surveys/surveys.component';
import { ToolkitComponent } from './toolkit/toolkit.component';
import { UploadpageComponent } from './uploadpage/uploadpage.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        // ChartsModule,
        FormsModule,
        // DataTablesModule,
        ImageCropperModule,
        BsDropdownModule.forRoot(),
        PdfViewerModule,
        NgxSliderModule,
        ModalModule.forRoot(),
        TabsModule.forRoot(),
        AccordionModule.forRoot(),
        CollapseModule.forRoot(),
        TooltipModule.forRoot(),
        BsDatepickerModule.forRoot(),
        NgxMaskModule.forRoot(),
        AppRoutingModule,
        MatCardModule,
        MatDialogModule,
        HttpClientModule,
        TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
          }
        })
    ],
    providers: [DatePipe],
    declarations: [
        PatientComponent,
        ActivityBoardComponent,
        AddcareComponent,
        AppointmentComponent,
        PAssementComponent,
        UploadpageComponent,
        ProfilequesComponent,
        HelpdeskpageComponent,
        CarefamilyComponent,
        DashboardComponent,
        DashboarddComponent,
        MessageComponent,
        MyprofileComponent,
        PatsyComponent,
        PostoperativeComponent,
        PreventinginfectionComponent,
        ReportComponent,
        SupportComponent,
        SurveysComponent,
        PainlevelComponent,
        DocumentComponent,
        ToolkitComponent,
        ContactmeComponent,
        DefaultcontactusComponent,
        PatientAssessmentDetailsComponent,
        OnlyAlphanumericDirective,
        OnlyNumberDirective,
        OnlycharactersDirective,
        StringFormatPipePipe,
        DateFormatPipe,
        SafeHtmlPipe,
        SafeHtmltestPipe,
        DateShort,
        DateMon,
        CustomMinDirective,
        CustomMaxDirective,
        ExercisevideosComponent,
        SucesstempComponent,
        DocumentsComponent


    ],
    entryComponents: [SucesstempComponent]
})
export class PatientModule { }
